import {PropertyOrKeyValue} from "../Node";
import {CameraNode} from "./environment/CameraNode";
import {RendererNode} from "./environment/RendererNode";
import {EnvironmentNode} from "./environment/EnvironmentNode";
import {AbstractMetaJsonNode} from "./AbstractMetaJsonNode";
import {PSubNode} from "../properties/PSubNode";
import {PAny} from "../properties/PAny";
import {MetadataRow} from "../../global";
import {PNodeListMeta} from "../properties/PNodeListMeta";

export class EnvironmentJson extends AbstractMetaJsonNode {

    id: number;
    name: string;
    environmentNode: EnvironmentNode;
    cameraNode: CameraNode;
    rendererNode: RendererNode;

    constructor(metaTable, meta) {
        super(metaTable, meta);
        this.rendererNode = new RendererNode();
        this.cameraNode = new CameraNode();
        this.environmentNode = new EnvironmentNode(this);
    }

    createProperties(): PropertyOrKeyValue[] {
        return [
            new PAny({
                name: 'id',
                type: 'Id',
                node: this,
                showInEditor: (p) => false,
                isThree: (p) => false
            }),
            new PAny({
                name: 'name',
                type: 'String',
                default: "Default",
                node: this,
                showInEditor: (p) => false,
                isThree: (p) => false
            }),
            {
                "group": "Environment"
            },
            new PSubNode({
                "name": "environmentNode",
                label: null,
                node: this
            }),
            {
                "group": "Camera"
            },
            new PSubNode({
                "name": "cameraNode",
                label: null,
                node: this
            }),
            {
                "group": "Renderer"
            },
            new PSubNode({
                "name": "rendererNode",
                label: null,
                node: this
            }),
        ];
    }

    init() {
        super.init();
        this.rendererNode.init();
        this.cameraNode.init();
        this.environmentNode.init();
        return this;
    }

    updateScene() {
        this._dataChanged = {};
        this.rendererNode.updateScene();
        this.cameraNode.updateScene();
        this.environmentNode.updateScene();
    }

    getName() {
        return "Environment";
    }

    getTableName() {
        return 'EnvironmentJson';
    }

    saveToServer(): Promise<boolean> {
        return super.saveToServer().then(()=>
            this.rendererNode.saveSettings());
    }

}
